var _mask, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMaskBanner = function SvgMaskBanner(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 77,
    viewBox: "0 0 343 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 343,
    height: 77
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 77,
    rx: 4,
    fill: "#227EFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.149 -72.4658L120.154 -72.4604L120.159 -72.4551L155.404 -35.9027C160.531 -30.5856 161.543 -22.527 157.89 -16.1136L132.734 28.048L132.73 28.0543L132.727 28.0607L108.949 72.946C105.487 79.4822 98.123 82.941 90.8796 81.4333L41.2702 71.1075L41.2631 71.106L41.2559 71.1047L-8.6461 62.3093C-15.9322 61.0251 -21.4986 55.0816 -22.3049 47.7253L-27.8422 -2.79288L-27.843 -2.80012L-27.844 -2.80732L-34.929 -53.1641C-35.9579 -60.4772 -32.0451 -67.5894 -25.3204 -70.6292L20.9081 -91.5263L20.9147 -91.5293L20.9213 -91.5325L66.4408 -113.818C73.0913 -117.074 81.0965 -115.536 86.0748 -110.045L120.149 -72.4658Z",
    fill: "#0350BB",
    stroke: "#64A4FF",
    strokeWidth: 0.950437
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.108 -62.0223L102.113 -62.0169L102.118 -62.0117L127.803 -35.3738C132.93 -30.0567 133.942 -21.9981 130.289 -15.5847L111.954 16.6025L111.95 16.6088L111.947 16.6152L94.6211 49.3219C91.1587 55.8581 83.7947 59.3169 76.5513 57.8092L40.4096 50.2866L40.4024 50.2851L40.3952 50.2838L4.04031 43.8761C-3.24576 42.5919 -8.81216 36.6485 -9.6185 29.2921L-13.6534 -7.51914L-13.6542 -7.52637L-13.6552 -7.53358L-18.8191 -44.236C-19.848 -51.5492 -15.9352 -58.6614 -9.21051 -61.7012L24.4789 -76.9301L24.4856 -76.9331L24.4921 -76.9364L57.6519 -93.1707C64.3024 -96.4266 72.3076 -94.8884 77.2859 -89.398L102.108 -62.0223Z",
    fill: "#0350BB",
    stroke: "#64A4FF",
    strokeWidth: 0.950437
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.2875 -58.2555L88.2924 -58.2501L88.2975 -58.2449L105.754 -40.1407C110.881 -34.8235 111.893 -26.7649 108.24 -20.3515L95.7763 1.52893L95.7727 1.53525L95.7693 1.54168L83.9962 23.766C80.5338 30.3021 73.1698 33.761 65.9265 32.2533L41.3766 27.1434L41.3695 27.1419L41.3623 27.1407L16.6676 22.7881C9.38152 21.5039 3.81514 15.5605 3.0088 8.20411L0.267086 -16.8092L0.266293 -16.8165L0.265278 -16.8237L-3.24508 -41.7736C-4.27401 -49.0867 -0.361182 -56.1989 6.3635 -59.2387L29.2603 -69.589L29.2669 -69.592L29.2735 -69.5952L51.7949 -80.6212C58.4454 -83.8772 66.4506 -82.3389 71.4289 -76.8485L88.2875 -58.2555Z",
    fill: "#0350BB",
    stroke: "#64A4FF",
    strokeWidth: 0.950437
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaskBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mask-banner.2a5cb4f6.svg";
export { ForwardRef as ReactComponent };